import React, { useState } from "react";
import { Box, FormControlLabel, Switch, Button, Typography, styled } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useTranslation } from "react-i18next";
import useInterval from "use-interval";

const BoxStyled = styled(Box)(({}) => ({
  width: "225px",
  padding: "0px 8px 8px 8px",
  display: "flex"
}));

const ButtonStyled = styled(Button)(({}) => ({
  marginRight: "1em",
  color: "primary"
}));

interface IRefreshProps {
  refreshSearch: () => void;
  disabled: boolean;
}

export function Refresh(refreshProps: IRefreshProps): React.ReactElement {
  const { t } = useTranslation();
  //const classes = useStyles();
  const [autoRefresh, setAutoRefresh] = useState(false);

  useInterval(
    () => {
      if (autoRefresh) {
        refreshProps.refreshSearch();
      }
    },
    //TODO reset the interval if the user change page, make a search, etc.
    10000
  );
  return (
    <BoxStyled flexDirection="column" justifyContent="center" alignItems="center">
      <Typography data-cy="refresh-label" variant="body2" color="textSecondary" style={{ fontSize: "10px" }}>
        {t("refresh")}
      </Typography>
      <Box display="flex">
        <ButtonStyled
          onClick={refreshProps.refreshSearch}
          variant="contained"
          disabled={refreshProps.disabled}
          data-cy="refresh-button">
          <RefreshIcon fontSize="large" />
        </ButtonStyled>

        <FormControlLabel
          control={
            <Switch
              value={autoRefresh}
              color="primary"
              onChange={() => {
                setAutoRefresh(!autoRefresh);
              }}
              checked={autoRefresh}
              data-cy="refresh-switch"
            />
          }
          label="Auto"
        />
      </Box>
    </BoxStyled>
  );
}
